import { Typography, useTheme } from "@mui/material";
import { MaterialUISwitch, LanguageSwitchRoot } from "./LanguageSwitch.styles";
import { useSelectedOptions } from "../../context/SelectedOptionsContext";

export const LanguageSwitch = ({ sx }) => {
  const { language, toggleLanguage } = useSelectedOptions();
  const theme = useTheme();

  return (
    <LanguageSwitchRoot sx={{ ...sx }}>
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          opacity: language === "en" ? 1 : 0.4,
          transition: "opacity 0.2s ease",
          color: theme?.palette?.companyColors?.secondary,
          textShadow: "0 0 3px 2px rgba(0,0,0,0.25)",
        }}
      >
        EN
      </Typography>
      <MaterialUISwitch
        checked={language === "de"}
        onChange={(e) => {
          toggleLanguage(e.target.checked === true ? "de" : "en");
        }}
      />
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          color: theme?.palette?.companyColors?.secondary,
          opacity: language === "de" ? 1 : 0.4,
          transition: "opacity 0.2s ease",
          textShadow: "0 0 3px 2px rgba(0,0,0,0.25)",
        }}
      >
        DE
      </Typography>
    </LanguageSwitchRoot>
  );
};
